import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';

function BrandIntro() {
  return (
    <section className="py-10">
      <h2 className="font-heading text-2xl font-bold text-foreground-900 mb-6">品牌介绍</h2>
      <div className="bg-background-100 rounded-lg p-6 md:p-8">
        <div className="flex flex-col md:flex-row gap-6 items-start">
          <div className="w-20 h-20 flex-shrink-0 rounded-full bg-primary-100 flex items-center justify-center text-3xl">
            🍉
          </div>
          <div>
            <h3 className="font-heading text-xl font-bold text-foreground-800 mb-3">关于吃瓜爆料</h3>
            <p className="text-foreground-700 leading-relaxed mb-3">
              <strong>吃瓜爆料</strong>是一个专注于娱乐八卦、社会热点和独家内幕爆料的资讯平台。我们致力于为用户提供<strong>最新、免费、真实</strong>的吃瓜内容，让每一位用户都能在第一时间获取到最热门的爆料资讯。
            </p>
            <p className="text-foreground-700 leading-relaxed mb-3">
              平台成立于2024年，由一群热爱追踪热点、关注社会动态的资深媒体人联合创办。我们秉持"吃的是瓜，追的是真相"的理念，坚持用专业的视角为读者呈现最有价值的资讯内容。
            </p>
            <p className="text-foreground-700 leading-relaxed">
              目前，吃瓜爆料已覆盖<strong>娱乐圈、网红圈、体育圈、科技圈、社会热点、国际视野</strong>六大核心板块，日均更新内容超过50篇，累计服务用户超过500万。
            </p>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-6">
        {[
          { num: '500万+', label: '累计用户' },
          { num: '50+', label: '日均更新' },
          { num: '6', label: '内容板块' },
          { num: '99.9%', label: '内容真实率' },
        ].map((stat) => (
          <div key={stat.label} className="text-center p-4 rounded-lg bg-background-100">
            <div className="font-heading text-2xl md:text-3xl font-bold text-primary-500">{stat.num}</div>
            <div className="text-sm text-foreground-500 mt-1">{stat.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
}

function Reputation() {
  const reviews = [
    {
      name: '追瓜小王',
      avatar: '👦',
      rating: 5,
      comment: '吃瓜爆料是我每天必看的网站！更新速度超快，很多独家内容别的平台根本找不到。已经推荐给身边所有的吃瓜好友了。',
      date: '2026-07-28',
    },
    {
      name: '娱乐圈观察家',
      avatar: '👩‍💼',
      rating: 5,
      comment: '作为一个媒体从业者，我很欣赏吃瓜爆料的专业态度。虽然有娱乐性质，但内容经得起推敲，不是那种随意编造的营销号。',
      date: '2026-07-25',
    },
    {
      name: '吃瓜群众小李',
      avatar: '👨',
      rating: 4,
      comment: '内容很丰富，分类也很清晰。希望可以增加更多互动功能，比如评论区可以点赞回复之类的，那样会更有意思。',
      date: '2026-07-22',
    },
    {
      name: '热心市民张姐',
      avatar: '👩‍🦰',
      rating: 5,
      comment: '自从发现了吃瓜爆料，再也不用到处找八卦看了。一个平台搞定所有！而且完全免费，真的良心。特别推荐给喜欢看热点的朋友们。',
      date: '2026-07-20',
    },
    {
      name: '体育迷阿涛',
      avatar: '🧑',
      rating: 5,
      comment: '体育圈的爆料太及时了！很多转会消息比官方公布还早，而且准确率很高。希望能继续加油，多做一些深度追踪报道。',
      date: '2026-07-18',
    },
    {
      name: '科技数码控',
      avatar: '👨‍💻',
      rating: 4,
      comment: '科技圈的爆料质量很高，不是那种抄来抄去的内容，有很多独家分析和一手的行业消息。推荐给每个关注科技动态的朋友。',
      date: '2026-07-15',
    },
  ];

  return (
    <section className="py-10 bg-background-100">
      <h2 className="font-heading text-2xl font-bold text-foreground-900 mb-2">用户口碑</h2>
      <p className="text-sm text-foreground-500 mb-6">来自真实用户的评价与反馈</p>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {reviews.map((review, idx) => (
          <div key={idx} className="bg-background-50 rounded-lg p-5">
            <div className="flex items-center gap-3 mb-3">
              <span className="text-2xl">{review.avatar}</span>
              <div>
                <h4 className="text-sm font-semibold text-foreground-800">{review.name}</h4>
                <div className="flex items-center gap-0.5">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i
                      key={i}
                      className={`text-xs ${i < review.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}
                    ></i>
                  ))}
                </div>
              </div>
              <span className="ml-auto text-xs text-foreground-400">{review.date}</span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">{review.comment}</p>
          </div>
        ))}
      </div>

      <div className="mt-8 bg-accent-50 rounded-lg p-6 text-center">
        <p className="text-lg font-heading font-bold text-accent-800 mb-1">用户满意度 98.7%</p>
        <p className="text-sm text-accent-600">基于10万+条真实用户反馈数据统计</p>
      </div>
    </section>
  );
}

function ContactInfo() {
  const [formStatus, setFormStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setFormStatus('idle');
    setFormError('');

    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = formData.get('website_alt');
    if (honeypot && String(honeypot).trim() !== '') {
      setFormStatus('success');
      return;
    }
    formData.delete('website_alt');

    try {
      const params = new URLSearchParams();
      formData.forEach((value, key) => {
        params.append(key, String(value));
      });
      const response = await fetch('https://readdy.ai/api/form/d9oqs4qqs38sj6jc7dv0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params.toString(),
      });
      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (response.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        form.reset();
      } else {
        const msg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || '提交失败，请稍后重试';
        setFormError(msg);
        setFormStatus('error');
      }
    } catch {
      setFormError('网络错误，请检查网络连接后重试');
      setFormStatus('error');
    }
  };

  return (
    <section className="py-10">
      <h2 className="font-heading text-2xl font-bold text-foreground-900 mb-6">联系我们</h2>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="flex flex-col gap-4">
          {[
            { icon: 'ri-mail-line', label: '电子邮箱', value: 'contact@udfujba.cn' },
            { icon: 'ri-wechat-fill', label: '微信公众号', value: '吃瓜爆料官方' },
            { icon: 'ri-weibo-fill', label: '新浪微博', value: '@吃瓜爆料官方微博' },
            { icon: 'ri-phone-line', label: '商务合作热线', value: '400-888-6666' },
            { icon: 'ri-map-pin-line', label: '公司地址', value: '北京市朝阳区光华路88号吃瓜大厦16层' },
          ].map((item) => (
            <div key={item.label} className="flex items-center gap-3 p-4 rounded-lg bg-background-100">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100">
                <i className={`${item.icon} text-primary-500`}></i>
              </div>
              <div>
                <p className="text-xs text-foreground-500">{item.label}</p>
                <p className="text-sm font-medium text-foreground-800">{item.value}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-background-100 rounded-lg p-6">
          <h3 className="font-heading text-lg font-bold text-foreground-800 mb-1">给我们留言</h3>
          <p className="text-sm text-foreground-500 mb-5">有任何建议或合作意向，欢迎随时联系我们。</p>
          <form className="flex flex-col gap-4" data-readdy-form="" onSubmit={handleSubmit}>
            <input
              type="text"
              name="website_alt"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              readOnly
              className="honeypot-field"
            />
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <input
                type="text"
                name="name"
                placeholder="你的姓名"
                className="px-4 py-3 rounded-md bg-background-50 border border-background-300 text-foreground-800 placeholder:text-foreground-400 text-sm outline-none focus:border-primary-400 transition-colors"
                required
              />
              <input
                type="email"
                name="email"
                placeholder="你的邮箱"
                className="px-4 py-3 rounded-md bg-background-50 border border-background-300 text-foreground-800 placeholder:text-foreground-400 text-sm outline-none focus:border-primary-400 transition-colors"
                required
              />
            </div>
            <input
              type="text"
              name="subject"
              placeholder="主题"
              className="px-4 py-3 rounded-md bg-background-50 border border-background-300 text-foreground-800 placeholder:text-foreground-400 text-sm outline-none focus:border-primary-400 transition-colors"
            />
            <textarea
              name="message"
              placeholder="你的留言（最多500字）"
              maxLength={500}
              rows={4}
              className="px-4 py-3 rounded-md bg-background-50 border border-background-300 text-foreground-800 placeholder:text-foreground-400 text-sm outline-none focus:border-primary-400 transition-colors resize-none"
              required
            ></textarea>
            <button
              type="submit"
              className="self-start px-6 py-3 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm whitespace-nowrap cursor-pointer transition-colors"
            >
              发送留言
            </button>
            {formStatus === 'success' && (
              <p className="text-sm text-green-600 mt-2">留言已发送，我们会尽快回复你！</p>
            )}
            {formStatus === 'error' && (
              <p className="text-sm text-red-500 mt-2">{formError}</p>
            )}
          </form>
        </div>
      </div>
    </section>
  );
}

function FAQSection() {
  const faqs = [
    {
      q: '吃瓜爆料的内容是否免费？',
      a: '是的！吃瓜爆料平台上的所有内容完全免费。我们坚信优质资讯应该向所有人开放，不设置任何付费墙或会员门槛。',
    },
    {
      q: '爆料内容的真实性如何保证？',
      a: '我们有一支专业的编辑团队，所有发布的内容都经过多重核实。对于来源不明或无法证实的信息，我们会明确标注"仅供参考"，让用户自行判断。',
    },
    {
      q: '如何订阅最新爆料推送？',
      a: '你可以在首页底部输入邮箱地址订阅我们的推送服务。订阅后，我们会在每天早8点和晚8点为你推送最新的吃瓜内容摘要。',
    },
    {
      q: '可以投稿或爆料吗？',
      a: '当然可以！欢迎通过"联系我们"中的邮箱或表单向我们投稿。如果你有独家内幕或一手资讯，我们会认真核实后发布，并标注你的贡献。',
    },
    {
      q: '吃瓜爆料有手机App吗？',
      a: '目前我们正在积极开发中，预计今年底推出iOS和Android客户端。敬请期待！在此之前，你可以通过手机浏览器访问我们的网站，体验已针对移动端进行了优化。',
    },
  ];

  return (
    <section className="py-10 bg-background-100">
      <h2 className="font-heading text-2xl font-bold text-foreground-900 mb-6">常见问题</h2>
      <div className="flex flex-col gap-3">
        {faqs.map((faq, idx) => (
          <details key={idx} className="group bg-background-50 rounded-lg">
            <summary className="flex items-center justify-between p-5 cursor-pointer list-none">
              <span className="text-sm font-semibold text-foreground-800 pr-4">{faq.q}</span>
              <i className="ri-arrow-down-s-line text-foreground-500 group-open:rotate-180 transition-transform flex-shrink-0"></i>
            </summary>
            <p className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
          </details>
        ))}
      </div>
    </section>
  );
}

export default function AboutPage() {
  return (
    <>
      <ScrollToTop />

      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'AboutPage',
        name: '关于我们 - 吃瓜爆料',
        description: '吃瓜爆料品牌介绍、用户口碑与联系方式，最新吃瓜爆料免费真实资讯平台',
        url: 'https://udfujba.cn/about',
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: '首页', item: 'https://udfujba.cn' },
            { '@type': 'ListItem', position: 2, name: '关于我们' },
          ],
        },
      }) }} />

      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: [
          { '@type': 'Question', name: '吃瓜爆料的内容是否免费？', acceptedAnswer: { '@type': 'Answer', text: '是的！吃瓜爆料平台上的所有内容完全免费。我们坚信优质资讯应该向所有人开放，不设置任何付费墙或会员门槛。' } },
          { '@type': 'Question', name: '爆料内容的真实性如何保证？', acceptedAnswer: { '@type': 'Answer', text: '我们有一支专业的编辑团队，所有发布的内容都经过多重核实。对于来源不明或无法证实的信息，我们会明确标注"仅供参考"。' } },
          { '@type': 'Question', name: '如何订阅最新爆料推送？', acceptedAnswer: { '@type': 'Answer', text: '你可以在首页底部输入邮箱地址订阅我们的推送服务。订阅后，我们会在每天早8点和晚8点为你推送最新的吃瓜内容摘要。' } },
          { '@type': 'Question', name: '可以投稿或爆料吗？', acceptedAnswer: { '@type': 'Answer', text: '当然可以！欢迎通过"联系我们"中的邮箱或表单向我们投稿。' } },
          { '@type': 'Question', name: '吃瓜爆料有手机App吗？', acceptedAnswer: { '@type': 'Answer', text: '目前我们正在积极开发中，预计今年底推出iOS和Android客户端。敬请期待！' } },
        ],
      }) }} />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-20">
          <div className="max-w-[1024px] mx-auto px-4 md:px-6">
            <div className="py-4">
              <Breadcrumb items={[{ label: '首页', href: '/' }, { label: '关于我们' }]} />
            </div>

            <header className="mb-4">
              <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900">关于我们</h1>
              <p className="text-foreground-500 mt-2">了解吃瓜爆料的故事、口碑和联系方式</p>
            </header>

            <BrandIntro />
            <Reputation />
            <ContactInfo />
            <FAQSection />
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
}